export default "fffd6a15f08ed026.svg"